import { isSupabaseConfigured } from '../lib/supabase.js';
import { signInWithEmail, signOut, getUser, isAuthenticated, onAuthChange } from '../lib/auth.js';
import { showToast } from '../editor/ui.js';

export function renderAuthButton() {
  const container = document.getElementById('nav-auth');
  if (!container) return;

  if (!isSupabaseConfigured()) {
    container.innerHTML = '';
    return;
  }

  function update() {
    container.innerHTML = '';
    if (isAuthenticated()) {
      const user = getUser();
      const name = user.user_metadata?.display_name || user.user_metadata?.full_name || user.email?.split('@')[0] || 'User';

      const userBtn = document.createElement('button');
      userBtn.className = 'auth-user-btn';
      userBtn.textContent = name;
      userBtn.addEventListener('click', () => {
        if (confirm('Sign out?')) {
          signOut();
        }
      });
      container.appendChild(userBtn);
    } else {
      const signInBtn = document.createElement('button');
      signInBtn.className = 'auth-signin-btn';
      signInBtn.textContent = 'Sign In';
      signInBtn.addEventListener('click', showAuthModal);
      container.appendChild(signInBtn);
    }
  }

  onAuthChange(update);
  update();
}

function showAuthModal() {
  const overlay = document.getElementById('modal-overlay');
  const modal = document.getElementById('modal');

  modal.innerHTML = `
    <h3>Sign In</h3>
    <p style="font-size:11px;color:var(--text);margin-bottom:16px;">
      Sign in to save animations to the cloud and share them publicly.
    </p>
    <!-- OAuth providers disabled until configured in Supabase
    <div class="auth-providers">
      <button class="auth-provider-btn" id="auth-github">
        Sign in with GitHub
      </button>
      <button class="auth-provider-btn" id="auth-google">
        Sign in with Google
      </button>
    </div>
    <div class="auth-divider"><span>or</span></div>
    -->
    <div class="auth-email-form">
      <input type="email" id="auth-email-input" placeholder="your@email.com"
        style="width:100%;background:var(--bg);border:1px solid var(--border);color:var(--text-bright);
               font-family:var(--font-mono);font-size:12px;padding:8px;border-radius:4px;">
      <button class="btn-primary" id="auth-email-submit" style="width:100%;margin-top:8px;padding:8px;
        background:var(--accent);color:#fff;border:1px solid var(--accent);border-radius:4px;
        font-family:var(--font-mono);font-size:12px;cursor:pointer;">
        Send Magic Link
      </button>
    </div>
    <div class="modal-actions" style="margin-top:16px;">
      <button class="btn-cancel" id="auth-cancel">Cancel</button>
    </div>
  `;

  overlay.classList.add('open');

  document.getElementById('auth-cancel').addEventListener('click', () => {
    overlay.classList.remove('open');
  });

  document.getElementById('auth-email-submit').addEventListener('click', async () => {
    const email = document.getElementById('auth-email-input').value.trim();
    if (!email) { showToast('Enter an email address'); return; }
    try {
      await signInWithEmail(email);
      overlay.classList.remove('open');
      showToast('Check your email for the magic link!');
    } catch (e) {
      showToast('Auth error: ' + e.message);
    }
  });

  document.getElementById('auth-email-input').addEventListener('keydown', (e) => {
    if (e.key === 'Enter') document.getElementById('auth-email-submit').click();
  });
}
